const defaultState = {
  data: [],
  tableLoading: false,
  tableCount: 0,
  tableSorted: {},
  view: '',
  subView: '',
  updateCount: 0,
  dancers: [],
  events: [],
  entries: [],
  event: {},
  competitions: [],
  organizerSchool: {},
  results: [],
  stats: {},
  schoolEntries: [],
  autosaved: {
    at: null,
    status: true,
    type: ''
  },
  competition: {
    entries: [],
    single: {},
    event: {},
    competition: {},
    template: {
      rounds: {
        1: {
          judges: [{}, {}, {}, {}, {}],
          scores: [[], [], [], [], []]
        },
        2: {
          judges: [{}, {}, {}, {}, {}],
          scores: [[], [], [], [], []]
        },
        3: {
          judges: [{}, {}, {}, {}, {}],
          scores: [[], [], [], [], []]
        }
      }
    }
  },
  organizerCompetition: {
    judgeEvents: []
  },
  template: {},
  mergeResponse: '',
  splitResponse: ''
};

const irishPoints = [
  100, 75, 65, 60, 56, 53, 50, 47, 45, 43, 41, 39, 38, 37, 36, 35, 34, 33, 32, 31, 30, 29, 28, 27,
  26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
];

function addScore(template, ro, state, entry, judgeIndex, val) {
  if (val > 100) {
    val = 100;
  }
  val = parseFloat(val);
  for (let i = 0; i < template.rounds[ro].scores[judgeIndex].length; i++) {
    let item = template.rounds[ro].scores[judgeIndex][i];
    if (item._id === entry._id) {
      template.rounds[ro].scores[judgeIndex][i]['round' + ro + 'Score'] = val;

      for (let r = 0; r < state.competition.competition.grade.rounds; r++) {
        let round = (r + 1).toString();
        // I can't wait to get rid of this. We have to do this because the records for the other rounds might be the same record
        // i.e. all 3 are the same record for a set panel and the records for rounds 1 and 2 are the same for split
        // since there may be different judge counts per round we need to make sure the array even exists
        if (template.rounds[round].scores[judgeIndex]) {
          for (let i = 0; i < template.rounds[round].scores[judgeIndex].length; i++) {
            let item = template.rounds[round].scores[judgeIndex][i];
            if (item.entryCompetition === entry.entryCompetition) {
              template.rounds[round].scores[judgeIndex][i]['round' + ro + 'Score'] = val;
            }
          }
        }
      }
    }
  }

  return template;
}

function updateEntryScore(template, state, entry, round, key, val) {
  let allRel = [];
  for (let r = 0; r < state.competition.competition.grade.rounds; r++) {
    for (let j = 0; j < state.competition.competition.grade.scoring.judge_count[r]; j++) {
      for (let it = 0; it < template.rounds[(r + 1).toString()].scores[j].length; it++) {
        let item = template.rounds[(r + 1).toString()].scores[j][it];
        if (item.entryCompetition === entry.entryCompetition) {
          allRel.push(item);
        }
      }
    }
  }

  for (let ar of allRel) {
    ar[key] = val;
  }

  return template;
}


const events = (state = defaultState, action) => {
  switch (action.type) {
    case 'TABULATOR_REMOVED_DANCER':
      let t9 = state.competition;

      t9.needsCalculation = true;
      t9.entries = t9.entries.filter(item => item._id !== action.payload.entryCompetitionId);

      for (let r9 of Object.keys(t9.template.rounds)) {
        //console.log("R", r);
        for (let s9 in t9.template.rounds[r9].scores) {
            t9.template.rounds[r9].scores[s9] = t9.template.rounds[r9].scores[s9].filter(item => item.entryCompetition !== action.payload.entryCompetitionId);
          
        }
      }
      
      return {
        ...state,
        competition: {
          ...t9,
          template: state.competition.template
        }
      };
    case 'TABULATOR_CHANGED_DANCER':
      let t2 = state.competition;

      let data2 = action.payload;
      if (data2.data.entry) {
        t2.entries = t2.entries.map((item) => {
          if (item._id === data2.oldId) {
            return data2.data.entry;
          } else {
            return item;
          }
        });

        for (let r2 of Object.keys(t2.template.rounds)) {
          //console.log("R", r);
          for (let s2 in t2.template.rounds[r2].scores) {
            if (data2.data.rounds[r2].scores[s2][0]) {
              t2.template.rounds[r2].scores[s2] = t2.template.rounds[r2].scores[s2].map((item) => {
                if (item.entryCompetition === data2.oldId) {
                  return {
                    ...item,
                    entryCompetition: data2.data.entry._id
                  };
                } else {
                  return item;
                }
              });
            }
          }
        }
      }

      return {
        ...state,
        competition: t2
      };
    case 'TABULATOR_ADDED_DANCER':
      let t = state.competition;

      let data = action.payload;
      //console.log("Caught add dancer", data);
      if (data.entry) {
        t.entries.push(data.entry);

        for (let r of Object.keys(t.template.rounds)) {
          //console.log("R", r);
          for (let s in t.template.rounds[r].scores) {
            if (data.rounds[r].scores[s][0]) {
              t.template.rounds[r].scores[s].push(data.rounds[r].scores[s][0]);
            }
          }
        }
      }

      //console.log("Setting template", t);

      return {
        ...state,
        competition: t
      };
    case 'UPLOADED_SCHEDULE':
      return {
        ...state,
        event: {
          ...state.event,
          schedule: action.payload.schedule
        }
      };
    case 'UPDATE_SCORE':
      let template = state.competition.template;
      let ro = action.payload.round.toString();
      console.log(' >> SCORING ...');
      template = addScore(
        template,
        ro,
        state,
        action.payload.entry,
        action.payload.judgeIndex,
        action.payload.value
      );

      return {
        ...state,
        competition: {
          ...state.competition,
          competition: {
            ...state.competition.competition,
            template: template
          }
        }
      };
    case 'UPDATE_COMMENTS':
      let rel = state.competition.template.rounds[action.payload.round].scores[
        action.payload.judgeIndex
      ].filter((item, index) => {
        return item._id === action.payload.entry._id;
      });

      rel[0]['round' + action.payload.round + 'Comments'] = action.payload.value;
      return {
        ...state,
        competition: {
          ...state.competition,
          competition: {
            ...state.competition.competition,
            template: {
              ...state.competition.competition.template
            }
          }
        }
      };
    case 'SET_COMP_GENERATING':
      return {
        ...state,
        competition: {
          ...state.competition,
          competition: {
            ...state.competition.competition,
            generatingResults: true
          }
        }
      };
    case 'UPDATE_COMP_RESULT_STATUS':
      console.log('Update Status');
      return {
        ...state,
        competition: {
          ...state.competition,
          competition: {
            ...state.competition.competition,
            ...action.payload,
            generatingResults: false
          }
        }
      };
    case 'UPDATE_COMP_RESULT_SUCCESS':
      return {
        ...state,
        competition: {
          ...state.competition,
          ...action.payload,
          competition: {
            ...state.competition.competition,
            needsCalculation: false,
            generatingResults: false
          }
        }
      };
    case 'GOT_ORGANIZER_COMPETITION':
      return {
        ...state,
        organizerCompetition: action.payload.data,
        autosaved: {
          at: null,
          status: false,
          type: ''
        }
      };

    case 'GOT_ORGANIZER_SCHOOL':
      return {
        ...state,
        organizerSchool: action.payload.school,
        schoolEntries: action.payload.entries
      };
    case 'AUTOSAVED':
      return {
        ...state,
        autosaved: {
          at: new Date(),
          status: true,
          type: action.payload.type
        }
      };
    case 'MANUAL_SAVE':
      return {
        ...state,
        loaded: true,
        autosaved: {
          at: new Date(),
          status: true,
          type: action.payload.type
        },
        competition: {
          ...state.competition,
          ...action.payload.compData
          }
        };
    case 'SET_EVENT_LOAD_STATE':
      return {
          ...state,
          loaded: action.payload
      }
    case 'GOT_EVENTS_DATA':
      return {
        ...state,
        tableLoading: false,
        tableCount: action.payload.count,
        data: action.payload.data,
        hasMore: action.payload.hasMore || false,
        view: action.payload.view,
        updateCount: state.updateCount + 1
      };
    case 'COMPLETE_JUDGE_COMPETITION':
      return {
        ...state,
        competition: state.competition
          ? {
              ...state.competition,
              judgeEvent: {
                ...state.competition.judgeEvent,
                ...action.payload
              }
            }
          : defaultState.competition
      };
    case 'UPDATE_JUDGE_COMPETITION':
      //console.log
      return {
        ...state,
        competition: {
          ...state.competition,
          entries: state.competition.entries.map((entry) => {
            let rel = action.payload.data.filter((d) => d._id === entry.score._id)[0];
            if (rel) {
              return {
                ...entry,
                score: rel
              };
            } else {
              return entry;
            }
          }),
          single: action.payload.data.filter((d) => d._id === state.competition.single.score._id)[0]
            ? {
                ...state.competition.single,
                score: action.payload.data.filter(
                  (d) => d._id === state.competition.single.score._id
                )[0],
                nextUrl: action.payload.nextUrl
              }
            : state.competition.single
        }
      };
    case 'GOT_JUDGE_COMPETITION':
      return {
        ...state,
        competition: action.payload
      };
    case 'GOT_MERGE_RESPONSE':
      return {
        ...state,
        mergeResponse: action.payload.data
      };
    case 'GOT_SPLIT_RESPONSE':
      return {
        ...state,
        splitResponse: action.payload.data
      };
    case 'GOT_TABULATOR_COMPETITION':
      return {
        ...state,
        loaded: true,
        competition: action.payload,
        autosaved: {
          at: null,
          status: false,
          type: ''
        }
      };

    case 'UPDATE_JUDGE_LABEL':
      let temp = {
        ...state.competition.template,
        rounds: {
          ...state.competition.template.rounds,
          [action.payload.round.toString()]: {
            ...state.competition.template.rounds[action.payload.round.toString()],
            judges: state.competition.template.rounds[action.payload.round.toString()].judges.map(
              (item, i) => {
                if (i === action.payload.judge) {
                  return {
                    ...item,
                    label: action.payload.val
                  };
                } else {
                  return item;
                }
              }
            ),
            scores: state.competition.template.rounds[action.payload.round.toString()].scores.map(
              (item, judgeIndex) => {
                if (judgeIndex === action.payload.judge) {
                  return state.competition.template.rounds[action.payload.round.toString()].scores[
                    judgeIndex
                  ].map((sc, i) => {
                    return {
                      ...sc,
                      judgeLabel: action.payload.val
                    };
                  });
                } else {
                  return item;
                }
              }
            )
          }
        }
      };

      return {
        ...state,
        competition: {
          ...state.competition,
          template: temp
        }
      };
    case 'UPDATE_ENTRYSCORE':
      let temp4 = state.competition.template;
      temp4 = updateEntryScore(
        temp4,
        state,
        action.payload.entry,
        action.payload.round,
        action.payload.key,
        action.payload.val
      );

      return {
        ...state,
        competition: {
          ...state.competition,
          template: temp4
        }
      };

    case 'UPDATE_STANDARD_JUDGE':

      // This is called by judgeStandardTable, which is only used for SET comps. So we update the judge on the record for every round
      let rounds = [];
      let i = 0;
      let judgeIndex = parseInt(action.payload.judge);
      while (i < state.competition.competition.grade.rounds) {
        rounds.push((i + 1).toString());
        state.competition.template.rounds[(i + 1).toString()].judges =
          state.competition.template.rounds[(i + 1).toString()].judges.map((item, index) => {
            if (index === judgeIndex) {
              return action.payload.val;
            } else {
              return item;
            }
          });

        state.competition.template.rounds[(i + 1).toString()].scores =
          state.competition.template.rounds[(i + 1).toString()].scores.map((item, index) => {
            if (index === judgeIndex) {
              return state.competition.template.rounds[(i + 1).toString()].scores[index].map(
                (sc, sci) => {
                  return {
                    ...sc,
                    judge: action.payload.val
                  };
                }
              );
            } else {
              return item;
            }
          });

        i++;
      }

      console.log('Adding judge', state.competition.template);

      return {
        ...state,
        competition: state.competition
      };
    case 'UPDATE_JUDGE':
      let tmp = {
        ...state.competition.template,
        rounds: {
          ...state.competition.template.rounds,
          [action.payload.round.toString()]: {
            ...state.competition.template.rounds[action.payload.round.toString()],
            judges: state.competition.template.rounds[action.payload.round.toString()].judges.map(
              (item, i) => {
                if (i === action.payload.judge) {
                  return action.payload.val;
                } else {
                  return item;
                }
              }
            ),
            scores: state.competition.template.rounds[action.payload.round.toString()].scores.map(
              (item, judgeIndex) => {
                if (judgeIndex === action.payload.judge) {
                  return state.competition.template.rounds[action.payload.round.toString()].scores[
                    judgeIndex
                  ].map((sc, i) => {
                    return {
                      ...sc,
                      judge: action.payload.val
                    };
                  });
                } else {
                  return item;
                }
              }
            )
          }
        }
      };

      return {
        ...state,
        competition: {
          ...state.competition,
          template: tmp
        }
      };
    case 'GENERATING_STATUS_CHANGED':
      return {
        ...state,
        event: {
          ...state.event,
          generatingData: action.payload
        }
      };

    case 'UPDATE_TABULATOR_COMPETITION':
      return {
        ...state,
        competition: {
          ...state.competition,
          competition: {
            ...state.competition.competition,
            template: action.payload.competition.template
          }
        }
      };
    case 'GOT_SINGLE_EVENT':
      return {
        ...state,
        event: action.payload
      };
    case 'LOGOUT':
      return defaultState;
    case 'PATCHED_SINGLE_EVENT':
      //console.log
      return {
        ...state,
        event: {
          ...state.event,
          ...action.payload
        }
      };
    case 'PATCHED_EVENT':
      return {
        ...state,
        event: {
          ...state.event,
          ...action.payload
        }
      };
    case 'GOT_MORE_EVENTS_DATA':
      return {
        ...state,
        tableLoading: false,
        tableCount: state.tableCount + action.payload.count,
        data: state.data.concat(
          action.payload.data.filter((d) => {
            return state.data.filter((f) => f._id === d._id).length === 0;
          })
        ),
        view: action.payload.view,
        hasMore: action.payload.hasMore || false,
        updateCount: state.updateCount + 1
      };
    default:
      return state;
  }
};

export default events;
